<template lang="pug">
  div.msn.separate-collection-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-subtitle(text="Реквизиты")
                e-form-group(
                  name="name"
                  inputType="input"
                  label="Идентификатор"
                  :model="fields"
                  :required="true"
                  tabView="tab1"
                )
                e-form-group(
                  name="owner"
                  inputType="input"
                  label="Балансодержатель"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="daily_norm"
                  inputType="input"
                  label="Суточная норма накопления, тонн"
                  :model="fields"
                  validationRule="double"
                  tabView="tab1"
                )

                e-form-group(
                  name="storage_location"
                  inputType="input"
                  label="Место накопления"
                  :model="fields"
                  tabView="tab1"
                )

                e-form-group(
                  name="responsible_executor"
                  inputType="input"
                  label="Ответственный исполнитель"
                  :model="fields"
                  tabView="tab1"
                )

                e-form-group(
                  name="responsible_executor_phone"
                  inputType="input"
                  label="Телефон ответственного исполнителя"
                  :model="fields"
                  tabView="tab1"
                )
              div.col
                div.col-block

                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab2"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )

                e-form-group(
                  name="status_id"
                  inputType="select"
                  :required="true"
                  label="Статус объекта"
                  :model="fields"
                  tabView="tab1"
                  :options="statuses"
                )
                e-form-group(
                  name="close_date"
                  inputType="calendar"
                  label="Дата закрытия"
                  :model="fields"
                  tabView="tab1"
                  :disabled="fields.status_id !== notActive"
                )

                e-form-group(
                  name="accepted_wastes"
                  label="Принимаемые отходы"
                  :model="fields"
                  :options="recyclableTypes"
                  inputType="suggestion[]"
                  tabView="tab1"
                )

                e-form-group(
                  name="msn_by_type_id"
                  inputType="select"
                  label="Тип площадки"
                  :model="fields"
                  tabView="tab1"
                  :options="msnByTypes"
                )

              div.col
                e-form-subtitle(text="Местоположение")
                e-location(
                  :formValidator="formValidator"
                  :model="fields"
                  name="address"
                  :required="true"
                  :addressData="addressData"
                  tabView="tab1"
                )
          // вкладка ОТХОДЫ
          div(v-show="tabView === 'tab2'")
            garbage-table(
              :id="fields.id"
              ref="garbageTable"
              tabView="tab2"
            )
          //вкладка ОБСЛУЖИВАНИЕ
          div(v-show="tabView === 'tab3'")
            service-table(
              :id="fields.id"
              ref="serviceTable"
              tabView="tab3"
            )
          //Журнал изменений
          div(v-show="tabView === 'tab4'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )
          //Документы
          div(v-show="tabView === 'tab5'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
</template>

<script>
  import { core, msn } from '../../api/api-endpoints.js'
  import msnForm from './mixins/msn-form.js'
  import GarbageTable from '../msn/components/garbage-table.vue'
  import ServiceTable from './components/service-table'

  export default {
    components: {
      GarbageTable,
      ServiceTable
    },
    mixins: [msnForm],
    data() {
      return {
        tabView: 'tab1',
        fields: {
          name: '',
          status_id: '',
          latitude: '',
          longitude: '',
          msn_type_id: 4,
          is_separate: 0
        },
        errors: null
      }
    },
    computed: {
      moduleId() {
        return this.moduleIds['msn']
      },
      tabs() {
        const tabs = [{ tab1: 'Общие сведения' }, { tab2: 'Отходы' }, { tab3: 'Обслуживание' }]
        if (this.fields.id) {
          tabs.push({ tab4: 'Журнал изменений' })
        }
        tabs.push({ tab5: 'Документы' })
        return tabs
      }
    },
    methods: {
      getCollectionEndpoint() {
        // return core.statuses({ fields: 'recyclable_type,msn_container_floor,msn_container_fence,status,msn_by_type' })
        return core.collection(
          'recyclable_type,msn_container_floor,msn_container_fence,status,msn_by_type',
          {query: {type: 'msn'}}
        )
      },
      getDeleteUrl(id) {
        return msn.containerDelete(id)
      },
      getUpdateOrCreateUrl() {
        return msn.containerUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint(route) {
        if (!route.params.id) {
          return null
        }
        return msn.container(route.params.id)
      }
    }
  }
</script>
